export default __webpack_public_path__ + "static/media/cta-collection.c491deb0.jpg";